import { FC } from 'react';
import { useDispatch } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { TableBody as Body } from '@mui/material';

import { Badge, TableNoData } from '../../shared/uiComponents';
import { HeaderProperties } from '../../shared/uiComponents/Table/tableProperties';
import { CustomTableRow, RowTableCell } from '../../shared/uiComponents/Table/tableHelpers';
import UserAction from '../../components/UserAction';

import { DispatchProperties } from '../../redux/store';
import { UserProperties } from '../../redux/API/userAPIProperties';
import { getClinicalSupervisors } from '../../redux/State/userSlice';
import { getBranchBadgeType } from '../../shared/Helpers/constants';

interface RowRendererProperties {
	data: UserProperties[];
}

export const Headers: HeaderProperties[] = [
	{ id: '8', name: 'Full Name', orderBy: 'fullName' },
	{ id: '1', name: 'Email', orderBy: 'email' },
	{ id: '3', name: 'Email Status', orderBy: 'emailConfirmed', width: '150px' },
	{ id: '4', name: 'Status', orderBy: 'isDeactivated', width: '100px' },
	{ id: '6', name: 'Role' },
	{ id: '9', name: 'Branch' },
	{ id: '7', name: 'Actions', width: '120px' },
];

export const TableBody: FC<RowRendererProperties> = ({ data }) => {
	const dispatch = useDispatch<DispatchProperties>();
	const [params] = useSearchParams();

	const fetchUsers = () => {
		const page = params.get('page') || '1';
		const pageSize = params.get('pageSize') || '8';
		const orderBy = params.get('orderBy') || '';
		const direction = params.get('direction') || '';
		const searchString = params.get('search') || '';

		dispatch(
			getClinicalSupervisors({
				page,
				pageSize,
				orderBy,
				direction,
				searchString,
			}),
		);
	};

	if (!data?.length) {
		return <TableNoData spanScope={Headers.length} />;
	}

	return (
		<Body>
			{data.map((row, index) => (
				<CustomTableRow key={index}>
					<RowTableCell>{row.fullName}</RowTableCell>
					<RowTableCell>{row.email}</RowTableCell>
					<RowTableCell>
						<Badge
							label={row.emailConfirmed ? 'Confirmed' : 'Pending'}
							sizeType="sm"
							type={row.emailConfirmed ? 'solidSuccess' : 'solidPrimary'}
						/>
					</RowTableCell>
					<RowTableCell>
						<Badge
							label={row.isDeactivated ? 'Inactive' : 'Active'}
							sizeType="sm"
							type={row.isDeactivated ? 'gray' : 'success'}
						/>
					</RowTableCell>
					<RowTableCell>{row.role.name}</RowTableCell>
					<RowTableCell>
						<div style={{ display: 'flex', gap: '4px', flexWrap: 'wrap' }}>
							{row.branches && row.branches.length > 0 ? (
								row.branches.map((branch) => (
									<Badge key={branch.id} label={branch.name} type={getBranchBadgeType(branch.state)} sizeType="sm" />
								))
							) : (
								<span style={{ color: '#999', fontSize: '12px' }}>None</span>
							)}
						</div>
					</RowTableCell>
					<RowTableCell>
						<UserAction item={row} fetchUsers={fetchUsers} />
					</RowTableCell>
				</CustomTableRow>
			))}
		</Body>
	);
};
